/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { languages } from '../../../ia/util/config';
import { nodesFactory } from '../nodes/factories';

const getLanguageLabel = languageCode => {
  if (!languageCode || !languages) {
    return 'UNKNOWN';
  }
  var option = languages.find(language => language.value === languageCode);
  if (!option || !option.label) {
    return 'UNKNOWN';
  }
  return option.label;
};

export function workspaceFactory(attributes) {
  const workspace = {
    workspace_id: attributes.workspace_id,
    name: attributes.name,
    description: attributes.description,
    language: attributes.language,
    created: attributes.created,
    created_by: attributes.created_by,
    metadata: attributes.metadata,
    modified: attributes.modified || attributes.updated,
    modified_by: attributes.modified_by,
    intents: attributes.intents,
    entities: attributes.entities,
    dialog_nodes: nodesFactory(attributes.dialog_nodes),
    counterexamples: attributes.counterexamples,
    language_label: getLanguageLabel(attributes.language),
    is_sample: attributes.is_sample,
    system_settings: attributes.system_settings,
    webhooks: attributes.webhooks
  };

  if (attributes.actions) {
    workspace.actions = attributes.actions;
  }

  if (attributes.counts) {
    const { intent, entity, node } = attributes.counts;

    workspace.counts = {
      intent,
      entity,
      node
    };
  }

  return workspace;
}
